/**
 * Wraps any chart/widget body with a consistent header (title + subtitle +
 * optional action slot) and card chrome. The action slot lets widgets
 * attach contextual UI: legend dot, sort toggle, "View all" link, etc.
 *
 * `padded={false}` flushes the body content to the card edges — used by
 * the technician ranking table where rows span the full width.
 */
import { Card } from "../../../../UI";
import { ChartCardStyles } from "./chartCard.styles";

const ChartCard = ({ title, subtitle, action, padded = true, children }) => (
  <ChartCardStyles>
    <Card className="chart-card">
      <div className="chart-card__head">
        <div className="chart-card__heading">
          <div className="chart-card__title">{title}</div>
          {subtitle && (
            <div className="chart-card__subtitle">{subtitle}</div>
          )}
        </div>
        {action && <div className="chart-card__action">{action}</div>}
      </div>
      <div
        className={`chart-card__body ${
          padded ? "chart-card__body--padded" : "chart-card__body--flush"
        }`}
      >
        {children}
      </div>
    </Card>
  </ChartCardStyles>
);

export default ChartCard;
